// extracted by mini-css-extract-plugin
export default {"tab":"burger-ingredients_tab__BINNt","tab_hover":"burger-ingredients_tab_hover__eP3eL","title":"burger-ingredients_title__7SklB"};